import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReadService } from './read.service';

import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class DashboardService extends ReadService<any, any> {
  url = '/api/dashboard';
  entityTitle = 'Dashboard';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getEngineius(): Promise<any> {
    return this.http
      .get(`${this.url}` + '/getEngineius')
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getCustomer(): Promise<any> {
    return this.http
      .get(`${this.url}` + '/getCustomer')
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getSupplier(): Promise<any> {
    return this.http
      .get(`${this.url}` + '/getSupplier')
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getRedirect(): Promise<string> {
    return this.http
      .get(`${this.url}/getRedirect`, { responseType: 'text', observe: 'body' })
      .toPromise();
  }
}
